/**
 * @module login 
 *  Apis must need auth details to trigger url - AuthApi
 */

import store from '@/store/store';
import Env from '@/env';
import NormalApis from '@/Components/Controllers/NormalApis';
import BusinessLoyalityApis from '@/Components/Controllers/BusinessLoyalityApis';

export default {
    /**
     * fetch business profile by business slug
     */
    fetchBusinessProfile(business_slug) {
        const url = `${Env.businessProfileUrl}/api/v1/businesses/slug/${business_slug}?withBranding=true&rgba=true`;
        return NormalApis.getApi(url, {
          'api-token': Env.businessProfileUrlApiToken,
        })
        .then( async (res) => {
          await store.dispatch('businessprofile/setDetail', res.data.payload);
          await BusinessLoyalityApis.fetchBusinessLoyality(res.data.payload.id);
          return res;
        })
        .catch(err => {
          store.dispatch('businessprofile/setDetail', {});
          store.dispatch('businessprofile/setBusinessLoyality', {});
          return err;
        });
    },
}